import Price from './Price';


Price.install = function(Vue) {
  Vue.component(Price.name, Price);
};

export default Price;
